import React, {Component} from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import ValueFormField from "../../components/forms/ValueFormField";
import FormError from "../../components/forms/FormError";
import FieldError from "../../components/forms/FieldError";
import "./SubscriptionProductsForm.css";
import "../../components/InlineTable.css";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return 0;
  if (parsed < 0) return 0;
  return parsed;
}

class SubscriptionProductsForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form className="SubscriptionProductsForm" onSubmit={handleSubmit}>
        <div className="fields">
          <FieldArray name="products" props={{serverError: errors.products}} component={this.renderMembers} />
          <FormFieldsTable>
            <Field
              label="Frequency Weeks"
              name="frequencyWeeks"
              type="number"
              component={TextInputField}
              normalize={numerical}
              />            
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }

  renderMembers({fields, meta: {error, submitFailed, dirty}, serverError}) {
    let products = fields.map((member, index) => {
      return (
        <tr key={index}>
          <td>
            <Field
              label="Product"
              name={`${member}.productTitle`}
              component={ValueFormField}
              table={false}
              />
          </td>
          <td className="u-no-wrap">
            <Field
              label="SKU"
              name={`${member}.productSku`}
              component={ValueFormField}
              table={false}
              />
          </td>
          <td className="u-no-wrap field-quantity">
            <Field
              label="Qty."
              name={`${member}.quantity`}
              type="number"
              component={TextInputField}
              normalize={numerical}
              table={false}
              />
          </td>
        </tr>
      );
    });

    return (
      <div className="products">
        <div className="InlineTable">
          <table>
            <thead>
              <tr>
                <td>Product</td>
                <td>SKU</td>
                <td>Qty.</td>  
              </tr>
            </thead>
            <tbody>
              {products}
            </tbody>
          </table>
        </div>
        <FieldError serverError={serverError} clientError={error} showClientError={dirty && error} />
      </div>
    )
  }
}

const ReduxForm = reduxForm({
  form: "SubscriptionProductsForm"
})(SubscriptionProductsForm);

export default ReduxForm;